/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { setIsRepaired, setRepairStepValid } from '../../../actions/claimSubmitActions';
import { navigateTo } from '../../../actions/navigationActions';
import './Glass.css';

class GlassRepairsYes extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {
            optionValue: "",
        };

        this.handleOnChange = this.handleOnChange.bind(this);
    }

    async handleOnChange(e) {
        this.setState({ optionValue: e.target.value });
        if (e.target.value === "repaired") {
            this.props.dispatcSetIsRepaired(true)
        }
        else {
            this.props.dispatcSetIsRepaired(false)
        }
        this.props.dispatchSetRepairStepValid(true);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    public render() {
        return (
            <>
                <div className="row noma mt-22px">
                    <div className="col-12 nopa">
                        <p className="text-16 mb-0px"><b>Select the option that applies to you</b></p>
                    </div>
                    <div className="col-12 nopa mt-15px">
                        <div className="form-check nopa mb-14px">
                            <input className="form-check-input radio-custom glassclaims-radio-custom" type="radio" name="radio-group" id="repairsRepaired" value="repaired" onChange={this.handleOnChange} />
                            <label className="form-check-label radio-custom-label glassclaims-radio-custom-label" htmlFor="repairsRepaired">
                                The glass was <b>repaired</b>
                            </label>
                        </div>
                        <div className="form-check nopa">
                            <input className="form-check-input radio-custom glassclaims-radio-custom" type="radio" name="radio-group" id="repairsReplaced" value="replaced" onChange={this.handleOnChange} />
                            <label className="form-check-label radio-custom-label glassclaims-radio-custom-label" htmlFor="repairsReplaced">
                                The glass was <b>replaced</b>
                            </label>
                        </div>
                    </div>
                </div>
                <hr className="mt-19px mb-0px glassclaims-hr-2px" />
                {this.state.optionValue !== "" && <div className="glass-repairs-pleaseNote-container mt-20px">
                    <p className="glass-repairs-please-note mb-0px"><b>Please note:</b><br />Keep your receipts and invoice as proof that your window/s have been replaced/repaired. </p>
                </div>}
            </>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatcSetIsRepaired: (value) => dispatch(setIsRepaired(value)),
        dispatchSetRepairStepValid: (value) => dispatch(setRepairStepValid(value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GlassRepairsYes)
